var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState, useRef, useEffect } from "react";
import { Accordion, AccordionSummary, Box, Typography, useMediaQuery } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { styled, useTheme } from "@mui/material/styles";
import { useEventZonedFormat } from "@/hooks/useZonedFormat";
export var AccordionDetails = styled(WizardStyles.AccordionDetails)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: 400px;\n    overflow-y: scroll;\n"], ["\n    max-height: 400px;\n    overflow-y: scroll;\n"])));
function usePreviousValue(value) {
    var ref = useRef(value);
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
export var Logs = function (_a) {
    var _b;
    var logs = _a.logs, event = _a.event;
    var _c = useState(true), logsExpanded = _c[0], setLogsExpanded = _c[1];
    var t = useTranslation().t;
    var format = useEventZonedFormat(event, { seconds: true });
    var theme = useTheme();
    var phone = useMediaQuery(theme.breakpoints.down("sm"));
    var myDivRef = useRef(null);
    var prevLogs = usePreviousValue(logs);
    useEffect(function () {
        if (!logsExpanded) {
            return;
        }
        if (!myDivRef.current) {
            return;
        }
        myDivRef.current.scroll({
            top: myDivRef.current.scrollHeight,
            behavior: "smooth",
        });
    }, [logsExpanded, myDivRef.current]);
    useEffect(function () {
        if (!logsExpanded) {
            return;
        }
        if (!myDivRef.current) {
            return;
        }
        var _a = myDivRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        var isNearBottom = scrollTop + clientHeight >= scrollHeight;
        if (isNearBottom || (prevLogs && logs && prevLogs.length < logs.length)) {
            myDivRef.current.scroll({
                top: myDivRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [logsExpanded, myDivRef.current, logs]);
    return (_jsxs(Accordion, { sx: { width: "100%" }, expanded: logsExpanded, onChange: function () { return setLogsExpanded(!logsExpanded); }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsx(WizardStyles.AccordionTitle, { children: t("keysGeneration.ceremonyStep.logsHeader.title") }) }), _jsx(AccordionDetails, { ref: myDivRef, children: !!logs && logs.length > 0 ? (_jsx(Paper, { sx: { width: "100%", margin: "4px 0" }, children: _jsx(TableContainer, { children: _jsxs(Table, { sx: { maxHeight: 450 }, "aria-label": "simple table", children: [phone ? null : (_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { sx: { width: "40%" }, children: t("keysGeneration.ceremonyStep.logsHeader.date") }), _jsx(TableCell, { align: "left", children: t("keysGeneration.ceremonyStep.logsHeader.entry") })] }) })), _jsx(TableBody, { children: (_b = logs.map(function (log, index) { return (_jsx(TableRow, { sx: {
                                            "&:last-child td, &:last-child th": {
                                                border: 0,
                                            },
                                        }, children: phone ? (_jsxs(TableCell, { component: "th", scope: "row", children: [_jsx(Box, { sx: { color: "text.secondary" }, children: format.format(log === null || log === void 0 ? void 0 : log.created_date) }), _jsx(Box, { children: log === null || log === void 0 ? void 0 : log.log_text })] })) : (_jsxs(_Fragment, { children: [_jsx(TableCell, { component: "th", scope: "row", children: format.format(log === null || log === void 0 ? void 0 : log.created_date) }), _jsx(TableCell, { align: "left", children: log === null || log === void 0 ? void 0 : log.log_text })] })) }, index)); })) !== null && _b !== void 0 ? _b : null })] }) }) })) : (_jsx(Box, { children: _jsx(Typography, { variant: "body2", children: t("keysGeneration.ceremonyStep.emptyLogs") }) })) })] }));
};
var templateObject_1;
